import { render, staticRenderFns } from "./CoinsPayment.vue?vue&type=template&id=ca5077da&scoped=true&"
import script from "./CoinsPayment.vue?vue&type=script&lang=js&"
export * from "./CoinsPayment.vue?vue&type=script&lang=js&"
import style0 from "./CoinsPayment.vue?vue&type=style&index=0&id=ca5077da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5077da",
  null
  
)

export default component.exports